/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UnproxiedMcpServerToolUsageRow,
  UnproxiedMcpServerToolUsageRow$inboundSchema,
} from "./unproxiedmcpservertoolusagerow.js";

/**
 * Result of a Shadow-MCP-backed per-tool usage lookup for an unproxied MCP server
 */
export type GetUnproxiedMcpServerToolUsageResult = {
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  tools: Array<UnproxiedMcpServerToolUsageRow>;
};

/** @internal */
export const GetUnproxiedMcpServerToolUsageResult$inboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerToolUsageResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    tools: z.array(UnproxiedMcpServerToolUsageRow$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function getUnproxiedMcpServerToolUsageResultFromJSON(
  jsonString: string,
): SafeParseResult<GetUnproxiedMcpServerToolUsageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetUnproxiedMcpServerToolUsageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetUnproxiedMcpServerToolUsageResult' from JSON`,
  );
}
